<p [innerHTML]="title || ('txt_stores_list_modal_list_title' | translate)"></p>

<ng-container *ngFor="let item of items">
  <a (click)="selectItem(item)">
    <gd-stores-list-item [name]="item?.name" [type]="item?.type"> </gd-stores-list-item>
  </a>
</ng-container>
